<template lang="pug">
IndexOriginal
</template>

<script setup>
import { useUrlModalTrigger } from '@/composables/ui/useUrlModalTrigger'
import { MODAL_INTENT } from '@/utils/urlModal'

definePageMeta({
  middleware: 'guest',
})

// 開窗、未開放註冊 fallback、?error= 守門、公告延後旗標統一由 composable 處理
// 規格：spec/JT-1784716920_url-modal-trigger-announcement-deferral.md
useUrlModalTrigger(MODAL_INTENT.REGISTER)
</script>

<style lang="scss" scoped></style>
